import React from "react";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AttentionPanel({ actions, onView }) {
  const total = actions?.total ?? 0;
  if (!total) {
    return (
      <div className="flex items-center justify-between rounded-lg border border-emerald-200 bg-emerald-50/70 px-4 py-2.5" data-testid="training-attention-none">
        <div className="flex items-center gap-2 text-emerald-900">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
          <span className="text-xs font-medium">All caught up — no training actions require attention right now.</span>
        </div>
      </div>
    );
  }
  const expired = actions?.expired?.length || 0;
  const expiring = actions?.expiring?.length || 0;
  const missing = actions?.missing?.length || 0;
  return (
    <div className="flex items-center justify-between rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5" data-testid="training-attention">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 rounded-lg bg-amber-100 border border-amber-200 flex items-center justify-center">
          <AlertTriangle className="w-4 h-4 text-amber-700" />
        </div>
        <div className="text-xs">
          <div className="font-medium text-amber-900" data-testid="training-attention-title">
            {total} training action{total === 1 ? "" : "s"} require attention
          </div>
          <div className="text-amber-800/80 mt-0.5">
            {expired > 0 && <span className="mr-2">{expired} expired</span>}
            {expiring > 0 && <span className="mr-2">· {expiring} expiring within 30 days</span>}
            {missing > 0 && <span>· {missing} mandatory gap{missing === 1 ? "" : "s"}</span>}
          </div>
        </div>
      </div>
      <Button variant="outline" size="sm" onClick={onView} data-testid="btn-attention-view" className="h-8 text-xs border-amber-300 hover:bg-amber-100 text-amber-900">
        View Actions <ChevronRight className="w-3.5 h-3.5 ml-1" />
      </Button>
    </div>
  );
}
